<nz-steps [nzCurrent]="currentStep()" nzSize="small" nzType="navigation">
	@let percent = (setupWizard.previewLoadingProgress$ | async) || 0;

	@for (crumb of breadcrumbs(); track crumb.name; let i = $index; let last = $last) {
		@switch (crumb.name) {
			@case (SetupWizardState.DASHBOARD) {
				<nz-step
					[nzTitle]="crumb.label"
					(click)="navigate(crumb.route)"
					[nzStatus]="percent === 100 ? 'finish' : 'process'"
					[nzIcon]="percent < 100 ? 'loading' : 'check'"
				/>
			}
			@case (SetupWizardState.EDIT_STEPS_ACCOUNT) {
				<nz-step
					[nzTitle]="crumb.label"
					(click)="navigate(crumb.route)"
					[nzStatus]="crumb.completed ? 'finish' : 'process'"
					[nzIcon]="percent < 100 ? 'loading' : crumb.completed ? 'check' : 'issues-close'"
					[nz-tooltip]="crumb.completed ? '' : 'This area needs attention for your account to be fully setup'"
				/>
			}
			@case (SetupWizardState.EDIT_STEPS_USERS) {
				<nz-step
					[nzTitle]="crumb.label"
					(click)="navigate(crumb.route)"
					[nzStatus]="crumb.completed ? 'finish' : 'process'"
					[nzIcon]="percent < 100 ? 'loading' : crumb.completed ? 'check' : 'issues-close'"
					[nz-tooltip]="crumb.completed ? '' : 'This area needs attention for your account to be fully setup'"
				/>
			}
			@case (SetupWizardState.EDIT_STEPS_LOCATIONS) {
				<nz-step
					[nzTitle]="crumb.label"
					(click)="navigate(crumb.route)"
					[nzStatus]="crumb.completed ? 'finish' : 'process'"
					[nzIcon]="percent < 100 ? 'loading' : crumb.completed ? 'check' : 'issues-close'"
					[nz-tooltip]="crumb.completed ? '' : 'This area needs attention for your account to be fully setup'"
				/>
			}
			@case (SetupWizardState.EDIT_STEPS_COURSES) {
				<nz-step
					[nzTitle]="crumb.label"
					(click)="navigate(crumb.route)"
					[nzStatus]="crumb.completed ? 'finish' : 'process'"
					[nzIcon]="percent < 100 ? 'loading' : crumb.completed ? 'check' : 'issues-close'"
					[nz-tooltip]="crumb.completed ? '' : 'This area needs attention for your account to be fully setup'"
				/>
			}
			@case (SetupWizardState.EDIT_STEPS_SECTIONS) {
				<nz-step
					[nzTitle]="crumb.label"
					(click)="navigate(crumb.route)"
					[nzStatus]="crumb.completed ? 'finish' : 'process'"
					[nzIcon]="percent < 100 ? 'loading' : crumb.completed ? 'check' : 'issues-close'"
					[nz-tooltip]="crumb.completed ? '' : 'This area needs attention for your account to be fully setup'"
				/>
			}
			@case (SetupWizardState.EDIT_STEPS_UNITS) {
				<nz-step
					[nzTitle]="crumb.label"
					(click)="navigate(crumb.route)"
					[nzStatus]="crumb.completed ? 'finish' : 'process'"
					[nzIcon]="percent < 100 ? 'loading' : crumb.completed ? 'check' : 'issues-close'"
					[nz-tooltip]="crumb.completed ? '' : 'This area needs attention for your account to be fully setup'"
				/>
			}
			@case (SetupWizardState.EDIT_STEPS_LESSONS) {
				<nz-step
					[nzTitle]="crumb.label"
					(click)="navigate(crumb.route)"
					[nzStatus]="crumb.completed ? 'finish' : 'process'"
					[nzIcon]="percent < 100 ? 'loading' : crumb.completed ? 'check' : 'issues-close'"
					[nz-tooltip]="crumb.completed ? '' : 'This area needs attention for your account to be fully setup'"
				/>
			}
			@case (SetupWizardState.EDIT_STEPS_ACTIVITIES) {
				<nz-step
					[nzTitle]="crumb.label"
					(click)="navigate(crumb.route)"
					[nzStatus]="crumb.completed ? 'finish' : 'process'"
					[nzIcon]="percent < 100 ? 'loading' : crumb.completed ? 'check' : 'issues-close'"
					[nz-tooltip]="crumb.completed ? '' : 'This area needs attention for your account to be fully setup'"
				/>
			}
			@case (SetupWizardState.EDIT_STEPS_CONTENTS) {
				<nz-step
					[nzTitle]="crumb.label"
					(click)="navigate(crumb.route)"
					[nzStatus]="crumb.completed ? 'finish' : 'process'"
					[nzIcon]="percent < 100 ? 'loading' : crumb.completed ? 'check' : 'issues-close'"
					[nz-tooltip]="crumb.completed ? '' : 'This area needs attention for your account to be fully setup'"
				/>
			}
			@case (SetupWizardState.PREVIEW_JOB) {
				<nz-step
					[nzTitle]="crumb.label"
					(click)="navigate(crumb.route)"
					[nzStatus]="crumb.completed ? 'finish' : 'process'"
					[nzIcon]="percent < 100 ? 'loading' : crumb.completed ? 'check' : 'issues-close'"
					[nz-tooltip]="crumb.completed ? '' : 'This area needs attention for your account to be fully setup'"
				/>
			}
		}
	}

	<nz-progress
		[nzPercent]="accountCompletedPercent()"
		nzType="circle"
		[nzWidth]="30"
		[nz-tooltip]="percent < 100 ? 'Your account is not fully setup yet' : 'Your account is fully setup!'"
	/>
</nz-steps>
